import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { TrainingService } from '../crud-service';
import { TrainingCrudIndex } from './crud-index';

@Component({
  selector: 'app-training-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [TrainingService],
})
export class TrainingIndexComponent extends TrainingCrudIndex {

  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'TITULO',
      name: 'trainingName',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT,
      label: 'TIPO',
      name: 'type',
      options: Object.values(SystemTypeEnum),
      placeholder: 'Selecione uma opção',
      validation: [Validators.required],
    }
  ];

  override submitAdvancedFilter(filterForm: any) {
    let _filterForm = this.getAdvancedFilters(filterForm.value);
    console.log('Parâmetros do filtro enviados:', _filterForm);

    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = this.getDataSource(data);
      });
  }

  private getAdvancedFilters(filter: any) {
    let params: any = {};

    if (filter.trainingName) params.trainingName = filter.trainingName.trim().toUpperCase();

    if (filter.type) {
      params.type = this.mapTypeToBackendValue(filter.type);
    }

    return params;
  }

  override getDataSource(data: any): MatTableDataSource<any> {
    return super.getDataSource(data);
  }

  override changePage(event: any) {
    super.changePage(event);
  }

  override handleTrainingFilter(filterData: any) {
    super.handleTrainingFilter(filterData);
  }

  private mapTypeToBackendValue(type: SystemTypeEnum): string | undefined {
    switch (type) {
      case SystemTypeEnum.APPLICATION:
        return SystemTypeIdEnum[SystemTypeEnum.APPLICATION] as unknown as string;
      case SystemTypeEnum.SYSTEM:
        return SystemTypeIdEnum[SystemTypeEnum.SYSTEM] as unknown as string;
      default:
        return undefined;
    }
  }
}
